// form
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, IconButton, InputAdornment, Stack } from "@mui/material";
import { FormProvider, RHFTextField } from "components/hook-form";
import { LoadingButton } from "@mui/lab";
import { useAppDispatch } from "app/hooks";
import { IUser } from "definitions/app/user";
import { addUserAsync, updateAUserAsync } from "app/services/users/userSlice";
import Iconify from "components/Iconify";
import { useState } from "react";

interface IUserForm extends IDrawerParent<IUser> {
  companyId?: string;
}

export const UserForm = ({ onParentClose, editData, readonly }: IUserForm) => {

  // redux
  const dispatch = useAppDispatch();

  // state
  const [showPassword, setShowPassword] = useState(false);

  // yup form
  let userSchema = Yup.object().shape({
    name: Yup.string().required("Name is Required"),
    gender: Yup.string().required("Gender is Required"),
    email: Yup.string().required("Email is Required"),
    login_type: Yup.string().required("User Type is Required"),
  });

  const defaultValues = {
    name: "",
    gender: "male",
    email: "",
    module: "",
    type: "Admin",
    ...(editData as any),
  };
  if (editData == null) {
    defaultValues["password"] = "";
    userSchema = userSchema.shape({
      password: Yup.string().min(5).required("Password is required"),
    });
  }
  const methods = useForm({
    resolver: yupResolver(userSchema),
    defaultValues,
  });
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data: typeof defaultValues) => {
    if (editData)
      dispatch(updateAUserAsync(data as any)).then(() => {
        onClose(data);
      });
    else
      dispatch(addUserAsync(data as any)).then(() => {
        onClose(data);
      });
  };

  const onClose = (data: any) => {
    onParentClose && onParentClose(data);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <RHFTextField
          readonly={readonly}
          name="name"
          label="Name"
        />

        {editData && readonly && (
          <RHFTextField
            readonly={true}
            name="mobile"
            label="Mobile Number"
          />
        )}
        <RHFTextField readonly={readonly} name="gender" label="Gender" />
        {editData?.email && (
          <RHFTextField readonly={readonly} name="email" label="Email" />
        )}
        {/* @ts-ignore */}
        {editData?.mobile && (
          <RHFTextField readonly={readonly} name="mobile" label="Mobile" />
        )}
        {/* @ts-ignore */}
        {editData?.address && (
          <RHFTextField
            readonly={readonly}
            name="address"
            label="Address"
          />
        )}
        {/* @ts-ignore */}
        {editData?.role && (
          <RHFTextField
            readonly={readonly}
            name="role"
            label="User Type"
          />)}
        {!editData && (
          <RHFTextField
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    <Iconify
                      icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                    />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      </Stack>

      <Grid container spacing={2} marginTop={4} justifyContent={"flex-end"}>
        <Grid item>
          <LoadingButton color="error" onClick={onClose}>
            Cancel
          </LoadingButton>
        </Grid>
        <Grid item>
          <LoadingButton
            disabled={readonly}
            type="submit"
            loading={isSubmitting}
            variant="contained"
          >
            Submit
          </LoadingButton>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
